'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { Table, TableHeader } from '@flipster/ui/Table';

import { desktopTabInfoMapper, spotDesktopTabInfoMapper } from '../../../constants';
import { marketPageBunja } from '../../../state';
import { SortKey, TableListProps } from '../../../types';
import { NoData } from '../no-data/no-data';
import { PageLink } from '../page-link';
import { DesktopRow } from './desktop-row';

export const DesktopTable = ({
  tab,
  items,
  pagination,
  setPage,
  getPageHref,
  isLoading,
  isSearching,
  onChangeSort,
}: TableListProps) => {
  const { tab: marketTab, discoverCursorAtom } = useBunja(marketPageBunja);
  const { sort } = useAtomValue(discoverCursorAtom);
  const tabInfo = marketTab === 'spot' ? spotDesktopTabInfoMapper[tab] : desktopTabInfoMapper[tab];

  return (
    <div>
      <Table
        isLoading={isLoading}
        tHeader={
          isSearching ? (
            <colgroup>
              <col />
              <col width='176' />
              <col width='176' />
              <col width='156' />
              <col width='144' />
            </colgroup>
          ) : (
            <TableHeader
              columns={tabInfo}
              sortKey={sort.sortKey}
              sortOrder={sort.sortOrder}
              onChangeSorting={([sortKey, sortOrder]) => {
                onChangeSort({ sortKey: sortKey as SortKey, sortOrder });
              }}
              className={css({
                p: '12px 16px',
                position: 'sticky',
                backgroundColor: 'background.default.level-0',
                zIndex: 1,
                top: 'calc(var(--current-navigation-height) + var(--market-discover-tab-height) + var(--market-tab-height) - 3px)',
              })}
            />
          )
        }
        items={items}
        renderRow={(v) => <DesktopRow key={`${tab}_${v.symbol}`} tab={tab} item={v} isSearching={isSearching} />}
        noData={isSearching ? <NoData /> : <FormattedMessage id='Common.r251015.No_data_found' />}
        withHover
      />
      {items && !isLoading && <PageLink {...pagination} onChange={setPage} getPageHref={getPageHref} />}
    </div>
  );
};
